export function sortRundownItems(itemsArray) {
    return _.orderBy(itemsArray, ['order', 'updated_at'], ['ASC', 'DESC']);
}
